export default __webpack_public_path__ + "static/media/Website Image-2.4ace1dd1.png";